module.exports = __webpack_public_path__ + "static/img/chose.d1e8b40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chose.png
// module id = cVbs
// module chunks = 0